export const API_ENDPOINTS = {
  USER_PROFILE: '/user/profile',
  NOTIFICATIONS: '/user/notifications',
  CLOSE_NOTIFICATION: '/user/notifications/:id/close',
  LOGIN: '/login',
  LOGOUT: '/logout',
  CONTRACTS: '/contracts',
  UPDATE_DETAILS: '/user/update',
  FILE_INIT: '/file/init',
  FILE_COMPLETE: '/file/complete',
  VERIFY_EMAIL: '/verify-email',
  RESET_PASSWORD: '/reset-password',
  REMOVE_USER: '/remove-user',
  SET_VERIFICATION_CODE: '/set-verification-code',
  REGISTRATION_ENTRY_LINK: '/registration-entry-link',
  INVITATION: '/invitations/:uuid',
  INVITATION_REGISTER: '/invitations/:uuid/register',
  INVITATION_VERIFY_CODE: '/invitations/:uuid/verify-code',
  RESEND_VERIFICATION_CODE: '/resend-verification-code',
  SEND_PASSWORD_RESET_CODE: '/send-password-reset-code',
  CONFIRM_RESET_PASSWORD: '/confirm-reset-password',
  CONFIRM_FORGOT_PASSWORD: '/confirm-forgot-password',
  DEFECT_CLASSES: '/defect-notice/classes',
  CREATE_DEFECT_NOTICE: '/defect-notice',
  DEFECT_NOTICES: '/contracts/:contractUuid/defect-notices',
  FEEDBACK_NOTICES: '/contracts/:contractUuid/feedbacks',
  QUESTION_NOTICES: '/contracts/:contractUuid/questions',
  DEFECT_NOTICE: '/contracts/:contractUuid/defect-notices/:defectNoticeUuid',
  CREATE_QUESTION: '/question',
  CREATE_FEEDBACK: '/feedback',
  EDIT_DEFECT_NOTICE:
    '/contracts/:contractUuid/defect-notice/:defectNoticeUuid',
  CONTRACT_CONTACTS: '/contracts/:uuid/contacts',
  CONTRACT_DOCUMENT_INFO: '/contracts/:uuid/contract-document',
  CONTRACT_DOCUMENT_CONTENT: '/contracts/:uuid/contract-document/content',
  FORGOT_PASSWORD: '/forgot-password',
  FEATURE_FLAGS: '/feature-flags',
  USER_METADATA: '/user/metadata',
  CONTRACT_TERMINATION_REQUEST: '/contracts/:uuid/termination',
  CONTRACT_MODIFICATION_REQUEST: '/contracts/:uuid/modification',
  CONTRACT_PARKING_SPOTS: '/contracts/:contractUuid/parking-spots',
  CONTRACT_PARKING_SPOT_RESERVATIONS:
    '/contracts/:contractUuid/parking-spots/reservations',
  CONTRACT_PARKING_SPOT_RESERVATIONS_TERMINATE:
    '/contracts/:contractUuid/parking-spots/reservations/terminate',
  CONTRACT_PARKING_SPOT_RESERVATIONS_CANCEL:
    '/contracts/:contractUuid/parking-spots/reservations/cancel',
  CONTRACT_DAY_RESERVABLE_AREAS:
    '/contracts/:contractUuid/day-reservable-areas',
  CONTRACT_DAY_RESERVABLE_AREA_RESERVATIONS:
    '/contracts/:contractUuid/day-reservable-areas/reservations',
  CONTRACT_DAY_RESERVABLE_AREA_RESERVATIONS_TERMINATE:
    '/contracts/:contractUuid/day-reservable-areas/reservations/terminate',
  CONTRACT_DAY_RESERVABLE_AREA_RESERVATIONS_CANCEL:
    '/contracts/:contractUuid/day-reservable-areas/reservations/cancel',
  BULLETINS: '/contracts/:contractUuid/bulletins',
  BULLETIN_LIST: '/contracts/:contractUuid/bulletin-list',
  BULLETIN: '/contracts/:contractUuid/bulletins/:bulletinUuid',
  USER_PERMISSIONS: '/user/permissions',
  BUILDING_INFO: '/contracts/:contractUuid/building-info',
  RESERVATION_CALENDARS: '/contracts/:contractUuid/reservation-calendars',
  RESERVATION_CALENDAR_TIME_SLOTS:
    '/contracts/:contractUuid/reservation-calendars/:calendarId/time-slots',
  RESERVATION_RULES_AND_TERMS:
    '/contracts/:contractUuid/reservation-rules-and-terms',
  RESERVATIONS: '/contracts/:contractUuid/reservations',
  RESERVATION_TERMINATE: '/contracts/:contractUuid/reservations/terminate',
  RESERVATION: '/contracts/:contractUuid/reservations/:id',
  RESERVATION_PINCODE:
    '/contracts/:contractUuid/reservations/:reservationId/pincode',
  RESERVATION_RECURRENCE_PINCODE:
    '/contracts/:contractUuid/reservations/recurrence/:reservationRecurrenceId/pincode',
  EXTRA_SERVICE_RESERVATIONS:
    '/contracts/:contractUuid/reservations/extra-services',
  CONTRACT_PART_PINCODE:
    '/contracts/:contractUuid/contract-parts/:contractPartId/pincode',
  INVOICE_ADDRESS: '/contracts/:contractUuid/invoice-address',
  RESIDENT_CONTRACT_PARKING_QUEUE:
    '/contracts/:contractUuid/parking-spots/queue',
  RESIDENT_CONTRACT_PARKING_QUEUE_ITEM:
    '/contracts/:contractUuid/parking-spots/:costPoolId/queue/:queueId',
  MODULE_CONFIG: '/module-config/:contractUuid',
  CLOUDWATCH_RUM_CONFIG: '/cloudwatch-rum-config',
  MESSAGE_TIMELINE: '/contracts/:contractUuid/message-timeline',
  MESSAGE_THREAD: '/contracts/:contractUuid/message-timeline/:threadUuid',
  MESSAGE_CATEGORIES: '/contracts/:contractUuid/message-categories',
  PENDING_OPERATIONS: '/pending-operations',
  REJECT_PENDING_OPERATION: '/pending-operations/:nonce/reject',
} as const
